import {Form} from "../utils/option-edit-form";
import draggableList from "../libs/draggable-list";
import {preventDefault} from "@fullcalendar/core/internal";

export default context => {
    const container = $('.edit-options-wrapper', context)
    if (!container.length) {
        return
    }

    draggableList(container.find('.options-list'), 'options-item', function (element) {
        const getSort = em => parseInt(em.querySelector('input[name=sort]').value)
        const setSort = (em, val) => $(em.querySelector('input[name=sort]')).val(val).trigger('change')

        let sort = getSort(element)

        if (!element.nextElementSibling && !element.previousElementSibling) {
            // the only
            return;
        }
        if (!element.nextElementSibling) {
            // the last one...
            const prevSort = getSort(element.previousElementSibling)
            if (sort < prevSort) {
                // ...when it was not.
                setSort(element, prevSort + 1)
            }
            return
        }
        if (!element.previousElementSibling) {
            // the first one...
            const nextSort = getSort(element.nextElementSibling)
            if (sort > nextSort) {
                // ...when it was not.
                setSort(element, nextSort - 1) // !todo can be less than 0.
            }
            return
        }
        // in the middle...
        let nextSort = getSort(element.nextElementSibling)
        let prevSort = getSort(element.previousElementSibling)

        if (sort < prevSort) {
            // ...moved down, so move others up.
            do {
                sort = getSort(element.nextElementSibling) - 1
                setSort(element, sort)
                element = element.previousElementSibling
            } while (element && getSort(element) >= sort);
        } else if (sort > nextSort) {
            //...moved up, so move others down.
            do {
                sort = getSort(element.previousElementSibling) + 1
                setSort(element, sort)
                element = element.nextElementSibling
            } while (element && getSort(element) <= sort);
        }
    })

    const list = $('.options-list')
    list.on('click', '.icon-edit', function () {
        const container = $(this).closest('[data-key]');
        if (!container.data('editable')) {
            return false
        }
        if (!container.data('modal')) {
            container.data('modal', new Form({
                field: container.find('input.data-input'),
                key: container.data('key'),
                type: container.data('form'),
                onHide: () => container.removeClass('open')
            }))
        }
        container.siblings('[data-key]').removeClass('open')
        container.data('modal').show(container)
        container.addClass('open')
    })
    list.on('click', '.icon-delete', function () {
        $(this).closest('.options-item').remove()
        refreshAddLinks()
        return false
    })
    list.on('click', '.icon-close', function () {
        $(this).closest('[data-key].open').removeClass('open')
    })

    $('.new-option-wrapper a', context).on('click', async function () {
        const keys = filterNotUsedOptions($(this).data('config') || [])
        if (keys.length === 0) {
            console.warn('No free keys to add an option')
            return false
        }
        const key = keys.shift()
        const data = await $.get('/site/options/get-data', {
            key: key,
            cid: window.cid,
            gid: $(this).closest('form').find('#editgroup-group_id').val(),
        })
        // override default values
        const value = data.value
        value.description = data.description
        value.show = 1
        value.force = 0
        value.show_admin = 0
        value.sort = getMaxSort(list) + 1
        value.label = translate.optionForm.defaultLabel
        if (value.values !== undefined) {
            value.values = []
        }
        insertTemplate(
            data.config.entity, key, data.config.type, value.label, data.config.form.icon, "", data.config.form.type, data.config.form.editable, data.config.form.permanent
        )
            .find('.data-input').val(JSON.stringify(value)).trigger('change')
            .prevObject.find('.icon-edit').trigger('click')
        refreshAddLinks()
        return false
    })

    // update list item text.
    list.on('change', '.data-input', function () {
        let data
        try {
            data = JSON.parse($(this).val())
        } catch (e) {
            data = {}
            console.warn(e)
            console.warn($(this).val())
        }
        if (data) {
            const dataInput = $(this)
            dataInput.siblings('.title').text(data.label)
            dataInput.siblings('input').each(function () {
                // no trigger here.
                $(this).val(data[$(this).attr('name')] || '')
            })
        }
    })

    list.on('change', '.input-field', function () {
        updateDataField($(this))
        updateFormField($(this))
    })
    // inline edit labels.
    // list.on('blur', '.inline-edit', function() {
    //     updateDataField($(this))
    //     $(this).removeClass('inline-edit').hide()
    //     $(this).siblings('.title').show()
    // })
    // list.on('keydown', '.inline-edit', function(event) {
    //     if(event.key === "Escape") {
    //         $(this).val($(this).siblings('.title').text())
    //         $(this).removeClass('inline-edit').hide()
    //         $(this).siblings('.title').show()
    //         return false
    //     }
    // })
    // list.on('click', '.title', function() {
    //     $(this).hide()
    //     $(this).siblings('input[name=label]').addClass('inline-edit').show().focus()
    // })

    const getMaxSort = function ($container) {
        let result = 0
        $container.find('input[name=sort]').each(function () {
            result = Math.max(parseInt($(this).val()) || 0, result)
        })
        return result
    }

    const updateDataField = function (sender) {
        const input = sender.closest('.options-item').find('.data-input')
        let data
        try {
            data = JSON.parse(input.val())
        } catch (e) {
            data = {}
            console.warn(e)
            console.warn($(this).val())
        }
        data[sender.attr('name')] = sender.val()
        data['skipsave'] = undefined
        input.val(JSON.stringify(data)).trigger('change')
    }

    const updateFormField = function (sender) {
        const name = sender.attr('name')
        sender.closest('.options-item').find(`.edit-option-form input[name=${name}]`).val(sender.val())
    }

    const refreshAddLinks = function () {
        $('.new-option-wrapper li a', context).each(function () {
            const data = $(this).data('config')
            if (filterNotUsedOptions(data).length > 0) {
                $(this).removeClass('hidden')
            } else {
                $(this).addClass('hidden')
            }
        })
    }

    const filterNotUsedOptions = function (values) {
        const used = list.find('.options-item[data-key]').map((i, e) => e.getAttribute('data-key')).get()
        return values.filter(value => !used.includes(value))
    }

    const insertTemplate = function (section, key, type, title, icon, value, form, editable, permanent) {
        const list = $('.options-list[data-section="' + section + '"]')
        const template = $(list.data('template')).html()
        const replace = {
            '%key': key,
            '%type': type,
            '%title': title,
            '%value': value,
            '%form': form,
            '%icon': icon,
            '%editable': editable ? '1' : '0',
            '%permanent': permanent ? '1' : '0',
        }
        return $(template.replaceAll(new RegExp(Object.keys(replace).join('|'), 'g'), (search) => replace[search]))
            .appendTo(list)
    }

    refreshAddLinks()
    list.find('input.data-input').trigger('change')

}
